import React, { useState } from "react";
import { useNavigate } from 'react-router-dom';
import { login } from "../../endpoints"
import Swal from "sweetalert2";
import CustomCircularProgress from "../../Components/Loading/CustomCircularProgress";
import {
  ContainerLogin,
  DivVertical,
  Title,
  Form,
  TextInput,
  TextError,
  Input,
  PasswordInput,
  InputContainer,
  LoginButton
} from "./styles"

const Login = () => {
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    email: '',
    password: '',
  });
  const [error, setError] = useState(null);

  const navigate = useNavigate()

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = async (e) => {
    setLoading(true)
    e.preventDefault();
    console.log(formData)
    if (formData.email && formData.password) {
      login({
        email: formData.email,
        password: formData.password
      })
        .then((response) => {
          if (response.status === 200) {

            localStorage.setItem("user", JSON.stringify(response.data));
            localStorage.setItem("alert", true);
            console.log(response.data);
            setLoading(false);
            navigate('/');
          }else {
            setLoading(false);
            Swal.fire({
              icon: "error",
              title: "Email o contraseña no coincide",
              confirmButtonText: "Listo",
              confirmButtonColor: "#003049",
              customClass: {
                title: 'my-custom-title-class'
              }
            });
          }
        })
        .catch((error) => {
          setLoading(false);
          console.log(error);
        });
    } else {
      setLoading(false);
      Swal.fire({
        icon: "error",
        title: "Campos email y contraseña son obligatorios",
        confirmButtonText: "Listo",
        confirmButtonColor: "#003049",
      });
    }
  };

  return (
  <ContainerLogin>
      <DivVertical>
        <Title>MERCI - CRM</Title>
        <Form onSubmit={handleSubmit}>
          <InputContainer>
            <TextInput>Email</TextInput>
            <Input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              placeholder='Ingresa tu email'
            />
          </InputContainer>
          <InputContainer>
            <TextInput>Contraseña</TextInput>
            <PasswordInput
              type="password"
              name="password"
              value={formData.password}
              onChange={handleChange}
              placeholder='Ingresa tu contraseña'
            />
          </InputContainer>
          {error && <TextError >Credenciales incorrectas, inténtelo de nuevo.</TextError>}
          <LoginButton type="submit" >
            {
              loading ?
                <CustomCircularProgress size={18} /> :
                "Iniciar sesión"
            }
          </LoginButton>
        </Form>
      </DivVertical>
  </ContainerLogin>
  );
};

export default Login;
